import "ngstorage";

class EventoverviewController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    EventsService,
    SecurityService,
    $rootScope,
    $scope,
    CommonService,
    EnvService,
    $timeout,
    $location
  ) {
    this.name = "eventoverview";
    $localStorage.activeStateName = "eventoverview";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$security = SecurityService;
    this.$rootScope = $rootScope;
    this.$common = CommonService;
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.$scope = $scope;
    this.isPrivate = false;
    this.isPreferred = false;
    this.remain_loading_count = 1;
    this.event = {};
    this.teamsPostedTo = [];
    this.acceptedApplicants = [];
    this.currentUser = this.$auth.getUserData();

    var _this = this;

    if (_this.currentUser.username.indexOf("jobble.com") !== -1 || _this.currentUser.username.indexOf("jobbleapp.com") !== -1) {
      _this.currentUser.isAdmin = true;
    }

    _this.$timeout(function () {
      _this.$rootScope.$emit("SetLoaderDialog", {type: 3, total: 1});
    });

    this.$events.getEventByIdTrimmed(this.$stateParams.eventId).then(
      function (data) {
        _this.event = data.data;
        _this.setHiringManager(_this.event.subEvents[0].deduppedJobbles[0].manager);

        if (_this.event.isSourcingPost) {
          _this.checkPayWage();
        }

        if (_this.event.isSourcingPost) {
          _this.postType = "source";
        } else {
          _this.postType = "regular";
        }

        var userTimeZoneName = moment.tz.guess();

        var now = moment.tz(userTimeZoneName);

        if (Object.keys(_this.event.subEvents[0].deduppedJobbles[0].circles).length !== 0) {
          try {
            if (_this.event.subEvents[0].deduppedJobbles[0].circles && _this.event.subEvents[0].deduppedJobbles[0].forCircleOnly) {
              _this.isPrivate = true;
            }

            if (_this.event.subEvents[0].deduppedJobbles[0].circles && !_this.event.subEvents[0].deduppedJobbles[0].forCircleOnly) {
              _this.isPreferred = true;
            }
          } finally {
            if (_this.isPreferred || _this.isPrivate) {
              _this.event.subEvents[0].deduppedJobbles[0].circles.forEach(function (team) {
                _this.teamsPostedTo.push(team.name);
              });
            }
          }
        }

        var minutes = _this.event.subEvents[0].deduppedJobbles[0].jobbleDuration * 60;
        var minRounder = minutes % 60;

        var hours = Math.floor(minutes / 60);
        _this.event.subEvents[0].deduppedJobbles[0].hours = hours;
        _this.event.subEvents[0].deduppedJobbles[0].minutes = minRounder;

        var userTimeZoneName = moment.tz.guess();
        var now = moment.tz(userTimeZoneName);

        try {
          for (var x = 0; x < _this.event.subEvents[0].deduppedJobbles[0].shifts.length; x++) {
            _this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.timeZoneId =
              _this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.place.timeZoneId;
            var nowThere = moment.tz(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.timeZoneId);
            var timeInSec = (parseInt(now.utcOffset(), 10) - parseInt(nowThere.utcOffset())) * 60;
            var startTimeAsMoment = moment(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime);
            var endTimeAsMoment = moment(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime);
            let st = _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime;
            let et = _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime;
            let tzid = _this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.timeZoneId;
            _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime = startTimeAsMoment.subtract(timeInSec, "seconds").format();
            _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime = endTimeAsMoment.subtract(timeInSec, "seconds").format();
            _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTimeFormatted = moment(
              moment.utc(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startTime).toDate()
            ).format("hh:mm A");
            _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.startDateFormatted = moment(st).tz(tzid).format("MMM DD, YYYY");
            _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime = moment(
              _this.event.subEvents[0].deduppedJobbles[0].shifts[x].timeInterval.endTime
            )
              .tz(_this.event.subEvents[0].deduppedJobbles[0].shifts[x].contactInfo.timeZoneId)
              .format();
          }
        } finally {
          _this.sortShiftsByStartTime();
        }

        if (_this.event.status === "error") {
          return;
        }

        _this.getApplicants();

        _this.$timeout(function () {
          _this.remain_loading_count--;
          _this.$rootScope.$emit("SetLoaderDialog", {type: 0});
          _this.$rootScope.$emit("SetEventToEventDialog", {
            event: _this.event,
          });
          _this.$rootScope.$emit("SetEventToEventSidebar", {
            event: _this.event,
          });
        }, 300);

        _this.$timeout(function () {
          $("eventsidebar .jobs-complete-sidebar li:nth-child(1)").removeClass().addClass("active");
        }, 500);
      },
      function (data) {
        _this.remain_loading_count--;

        $state.go("events");
      }
    );

    _this.SetEventToEventPagesListener = _this.$rootScope.$on("SetEventToEventPages", function ($event, params) {
      if (_this.event.id === params.event.id) {
        _this.event.cost = params.event.cost;
        if (params.openings) {
          if (params.action === "Add") {
            _this.event.numberOfOpenings = _this.event.numberOfOpenings + params.openings;
          } else {
            _this.event.numberOfOpenings = _this.event.numberOfOpenings - params.openings;
          }
        }
        _this.event.totalNumberOfJobbles = params.event.totalNumberOfJobbles;
      }
    });

    _this.SuccessToDeleteEventListener = this.$rootScope.$on("SuccessToDeleteEvent", function () {
      _this.$state.go("jobsdashboard");
    });

    _this.$scope.$on("$destroy", _this.SetEventToEventPagesListener);
    _this.$scope.$on("$destroy", _this.SuccessToDeleteEventListener);
  }

  getLocation() {
    if (this.$security.isUndefinedOrNull(this.event)) {
      return "";
    }
    var location = this.event.firstLocation.streetLine1;
    if (!this.$security.isUndefinedOrNull(this.event.firstLocation.city)) {
      location += " " + this.event.firstLocation.city;
    }
    if (!this.$security.isUndefinedOrNull(this.event.firstLocation.state)) {
      location += ", " + this.event.firstLocation.state;
    }

    if (!this.$security.isUndefinedOrNull(this.event.firstLocation.zipCode)) {
      location += " " + this.event.firstLocation.zipCode;
    }

    return location;
  }

  getShiftLocation(shift) {
    if (this.$security.isUndefinedOrNull(shift.contactInfo)) {
      return "";
    }
    var location = shift.contactInfo.streetLine1;
    if (!this.$security.isUndefinedOrNull(shift.contactInfo.city)) {
      location += " " + shift.contactInfo.city;
    }
    if (!this.$security.isUndefinedOrNull(shift.contactInfo.state)) {
      location += ", " + shift.contactInfo.state;
    }

    if (!this.$security.isUndefinedOrNull(shift.contactInfo.zipCode)) {
      location += " " + shift.contactInfo.zipCode;
    }

    return location;
  }

  getCurrency(cents) {
    console.log("what are the centers");
    console.dir(cents);
    //console.dir(numeral(cents / 100).format('$0,0.00'));
    return numeral(cents / 100).format("$0,0.00");
  }

  getEventDate(raw_date) {
    var date = new Date(raw_date);
    return moment(date).format("MMM DD, YYYY");
  }

  getTimeWithTimezone(utcTimeStr) {
    return utcTimeStr;
  }

  getDurationWithHoursAndMinutes(totalMinutes) {
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    return hours + "h " + minutes + "min";
  }

  displayTimeZone(tz) {
    if (tz === "Eastern Standard Time") {
      return "EST";
    }
    if (tz === "Central Standard Time") {
      return "CST";
    }
    if (tz === "Mountain Standard Time") {
      return "MST";
    }
    if (tz === "Pacific Standard Time") {
      return "PST";
    }
    if (tz === "Alaska Standard Time") {
      return "AST";
    }
    if (tz === "Hawaii Standard Time") {
      return "HST";
    }
  }

  getDaysFromStartToEnd(startTime, endTime) {
    var startMomentTime = moment(startTime);
    var endMomentTime = moment(endTime);
    var durationDays = endMomentTime.diff(startMomentTime, "days");

    return durationDays;
  }

  getHoursAndMintuesFromStartToEnd(startTime, endTime) {
    var startMomentTime = moment(startTime);
    var endMomentTime = moment(endTime);
    var durationMinutes = endMomentTime.diff(startMomentTime, "minutes");

    return this.getDurationWithHoursAndMinutes(durationMinutes);
  }

  getRatingPicUrl(application) {
    var rating = Math.round(application.applicant.averageRatingReceived);
    var ratingUrl;

    ratingUrl = "/app/vendor/images/rating-1.png";
    return ratingUrl;
  }

  displayDetails(application, type, action, index, isLink) {
    var _this = this;

    if (type === "default" || type === "hired") {
      if (!application.direction && !isLink) {
        _this.$timeout(function () {
          jQuery("#modal-view-jobble-click").trigger("click");
        });
      }
    }

    _this.$security.getApplicationInfoTrimmed(application).then(function (response) {
      var jobblerData = _this.$security.getJobblerData(response.data, type, action);

      jobblerData.isOverview = true;

      _this.$location.search("id", jobblerData.jobblerId);

      _this.$timeout(function () {
        _this.$rootScope.$emit("GetJobblerDataFromService", {
          event: _this.event,
          jobblerData: jobblerData,
        });
        jQuery("#modal-view-jobble").focus();
      });
    });
  }

  getCost(totalNumberOfJobbles, acceptedApplicantsCount, payRate, durationInMinutes, status) {
    /*
	  console.log('totalNumberOfJobbles');
	  console.dir(totalNumberOfJobbles);
	  console.dir(acceptedApplicantsCount);
	  console.dir(payRate);
	  console.dir(durationInMinutes);
	  */
    var cost = 0;

    if (status === 1) {
      cost = (acceptedApplicantsCount * payRate * durationInMinutes) / 60;
      //console.log('here is the cost...');
      //console.dir(cost);
    } else {
      cost = (totalNumberOfJobbles * payRate * durationInMinutes) / 60;
    }

    return numeral(cost / 100).format("$0,0.00");
  }

  setJobblerRating(acceptedApplication) {
    var _this = this;

    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 0) {
      acceptedApplication.applicant.displayRating = "one";
    }
    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 1) {
      acceptedApplication.applicant.displayRating = "one";
    }
    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 2) {
      acceptedApplication.applicant.displayRating = "two";
    }
    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 3) {
      acceptedApplication.applicant.displayRating = "three";
    }
    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 4) {
      acceptedApplication.applicant.displayRating = "four";
    }
    if (Math.round(acceptedApplication.applicant.averageRatingReceived) === 5) {
      acceptedApplication.applicant.displayRating = "five";
    }

    _this.noOneAcceptedYet = false;
    _this.acceptedApplicants.push(acceptedApplication);
  }

  sortShiftsByStartTime() {
    var _this = this;
    _this.event.subEvents[0].deduppedJobbles[0].shifts.sort(function (a, b) {
      return new Date(a.timeInterval.startTime).getTime() - new Date(b.timeInterval.startTime).getTime();
    });

    _this.checkForDelivery();
  }

  checkForDelivery() {
    var _this = this;
    if (_this.event.isOrder || _this.event.orderNumber) {
      _this.delivery = true;
    }

    _this.gatherTeamNames();
  }

  gatherTeamNames() {
    var _this = this;
    console.log("gatherTeamNames");
    console.dir(_this.event.subEvents[0].deduppedJobbles[0].circles);
    let circle_names = [];
    let circles = _this.event.subEvents[0].deduppedJobbles[0].circles;
    if (circles) {
      if (circles.length > 0) {
        try {
          circles.forEach(function (circ) {
            circle_names.push(circ.name);
          });
        } finally {
          _this.circ_names = circle_names;
          console.log("circ_names");
          console.dir(_this.circ_names);
        }
      }
    }
  }

  getExipryDate(startTime, endTime) {
    var _this = this;
    return moment(endTime).diff(moment(startTime), "days");
  }

  checkPayWage() {
    var _this = this;
  }

  getApplicants(offset) {
    var _this = this;
    console.log("getApplicants");
    console.log(offset);
    if (!offset) {
      _this.loading_applicants = true;
      offset = 0;
    }
    _this.$events.getAcceptedApplicationsTrimmedReview(_this.event.subEvents[0].id, 10, offset).then(
      function (acceptedApplications) {
        console.log("response length");
        console.dir(acceptedApplications.data.length);
        console.dir(acceptedApplications.data);
        if (acceptedApplications.data.length !== 0) {
          try {
            acceptedApplications.data.forEach(function (acceptedApplication) {
              acceptedApplication.renderPhotoThumb = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
              acceptedApplication.renderPhoto = acceptedApplication.applicant.filePROFILE_IMAGE1IMG_75x75;
              _this.setJobblerRating(acceptedApplication);
            });
          } catch (err) {
            console.log("err");
            console.dir(err);
          } finally {
            _this.fancyLoad(".overview-review-table-box .accepted-applicants-triple-list li", _this.acceptedApplicants.length);
            if (acceptedApplications.data.length < 10) {
              _this.loading_applicants = false;
              _this.sortApplicantsByName();
            } else {
              _this.getApplicants(_this.acceptedApplicants.length);
            }
          }
        } else {
          _this.$timeout(function () {
            _this.loading_applicants = false;
          }, 1500);
        }
      },
      function (data) {
        _this.remain_loading_count--;
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  sortApplicantsByName() {
    var _this = this;
    _this.$timeout(function () {
      _this.acceptedApplicants.sort(function (a, b) {
        if (a.applicant.lastName < b.applicant.lastName) return -1;
        if (a.applicant.lastName > b.applicant.lastName) return 1;
        return 0;
      });
    }, 500);
  }

  fancyLoad(cls, length) {
    var _this = this;
    _this.$auth.fancyLoad(cls, length);
  }

  setHiringManager(manager) {
    var _this = this;
    if (manager.id) {
      let manager_data = {};
      manager_data.name = manager.firstName + " " + manager.lastName;
      manager_data.phone = manager.homeContactInfo.phoneMobile;
      manager_data.email = manager.email;

      _this.manager = manager_data;
    }
  }

  formatNumber(number_input) {
    if (number_input) {
      if (number_input.length > 10) {
        let num = number_input.length - 10;
        number_input = number_input.substring(num, number_input.length);
      }
      let number = ("" + number_input).replace(/\D/g, "");
      let m = number.match(/^(\d{3})(\d{3})(\d{4})$/);

      return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
    }
  }
}

EventoverviewController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "events",
  "security",
  "$rootScope",
  "$scope",
  "common",
  "env",
  "$timeout",
  "$location",
];

export default EventoverviewController;



// WEBPACK FOOTER //
// ./client/app/components/eventoverview/eventoverview.controller.js